import { render, staticRenderFns } from "./TrainingSessionAttendanceUpdateCpt.vue?vue&type=template&id=cb1b0cbe&scoped=true&"
import script from "./TrainingSessionAttendanceUpdateCpt.vue?vue&type=script&lang=ts&"
export * from "./TrainingSessionAttendanceUpdateCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1b0cbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VContainer,VSimpleCheckbox})
